//export default 'http://sleep-well.coach:8080'
//export default 'https://api.sleep-well.coach'
//export default 'http://localhost:3000';
export default process.env.VUE_APP_API_URL;
